import MUISlider from "@mui/material/Slider";
import { useState } from "react";

export const Slider = ({
  defaultValue,
  onChange,
}: {
  defaultValue: number;
  onChange: (value: number) => void;
}) => {
  const [value, setValue] = useState(defaultValue);

  const handleOnChange = (value: unknown) => {
    if (typeof value !== "number") return;
    setValue(value);
    onChange(value);
  };

  return (
    <MUISlider
      aria-label="risk level slider"
      defaultValue={defaultValue}
      value={value}
      step={1}
      min={1}
      max={10}
      onChange={(_event, value) => handleOnChange(value)}
      sx={{
        height: "14px",
        ".MuiSlider-thumb": {
          width: "30px",
          height: "30px",
          backgroundColor: "#00bc75",
          "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
            boxShadow: "inherit",
          },
        },
        ".MuiSlider-track": {
          backgroundColor: "#3AD29F",
          border: "none",
        },
        ".MuiSlider-rail": {
          backgroundImage:
            "linear-gradient(to top, rgb(238, 238, 238), rgb(180, 180, 180))",
        },
      }}
    />
  );
};
